import { useCallback, useEffect } from "react";

export default function useKeyboardShortcut(
  keyCombination: string,
  callback: () => void
): void {
  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      const withControlKey = event.ctrlKey || event.metaKey ? "Ctrl+" : "";
      const withShiftKey = event.shiftKey ? "Shift+" : "";
      const withAltKey = event.altKey ? "Alt+" : "";
      const keyCode =
        event.key && event.key.length == 1
          ? event.key.toUpperCase()
          : event.key;

      const currentKeyCombinations =
        withControlKey + withShiftKey + withAltKey + keyCode;

      if (keyCombination === currentKeyCombinations) {
        event.preventDefault();
        callback();
      }
    },
    [callback, keyCombination]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [handleKeyPress]);
}
